"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiringProcessColumns = HiringProcessColumns;
const jsx_runtime_1 = require("react/jsx-runtime");
/* eslint-disable no-param-reassign */
const react_1 = __importDefault(require("react"));
const immer_1 = __importDefault(require("immer"));
const react_beautiful_dnd_1 = require("react-beautiful-dnd");
const lodash_1 = require("lodash");
const antd_1 = require("antd");
const Api = __importStar(require("@src/api"));
const types_1 = require("@src/types");
const styled_breakpoints_1 = require("styled-breakpoints");
const react_styled_1 = require("styled-breakpoints/react-styled");
const HiringProcessColumns_style_1 = require("./HiringProcessColumns.style");
const HiringProcessHeader_1 = require("../HiringProcessHeader");
const HiringProcessColumn_1 = require("./HiringProcessColumn");
function reorder(list, startIndex, endIndex) {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    return result;
}
function replaceOrReorderCards(destination, draft, application) {
    if (!draft) {
        return;
    }
    // @ts-ignore
    const startColumn = application.hiringProcessStage.name;
    const applicationStartIndex = (0, lodash_1.findIndex)(draft[startColumn], { id: application.id });
    if ((destination === null || destination === void 0 ? void 0 : destination.droppableId) === startColumn) {
        draft[destination === null || destination === void 0 ? void 0 : destination.droppableId] = reorder(draft[destination === null || destination === void 0 ? void 0 : destination.droppableId], applicationStartIndex, destination === null || destination === void 0 ? void 0 : destination.index);
    }
    else {
        draft[destination.droppableId].splice(destination.index, 0, application);
        draft[startColumn].splice(applicationStartIndex, 1);
    }
}
function actualizeApplicationsOrSelectedApplicationsState(applications, application, destinationStage, applicationsChangingStage) {
    const actualizedApplications = (0, immer_1.default)(applications, applicationsDraft => {
        const applicationToStageChange = applicationsDraft.find(app => app.id === application.id);
        // @ts-ignore
        applicationToStageChange.hiringProcessStage.name = destinationStage;
    });
    const applicationWithNewStage = actualizedApplications.find(app => app.id === application.id);
    applicationsChangingStage.push(applicationWithNewStage);
}
function actualizeOfferApplicationStatuses(destination, selectedApplications, applications, applicationGroups, applicationsChangingStage, selectedApplicationsChangingStage, draggableId) {
    const draggedApplicationId = Number(draggableId);
    const newStage = destination.droppableId;
    const newApplicationGroups = (0, immer_1.default)(applicationGroups, groupDraft => {
        const draggedApplication = applications.find(app => app.id === draggedApplicationId);
        if (selectedApplications.length > 1) {
            selectedApplications.forEach(application => {
                replaceOrReorderCards(destination, groupDraft, application);
                actualizeApplicationsOrSelectedApplicationsState(selectedApplications, application, newStage, selectedApplicationsChangingStage);
                actualizeApplicationsOrSelectedApplicationsState(applications, application, newStage, applicationsChangingStage);
            });
        }
        else {
            replaceOrReorderCards(destination, groupDraft, draggedApplication);
            const isApplicationSelected = selectedApplications.some(app => app.id === draggedApplication.id);
            if (isApplicationSelected) {
                actualizeApplicationsOrSelectedApplicationsState(selectedApplications, draggedApplication, newStage, selectedApplicationsChangingStage);
            }
            actualizeApplicationsOrSelectedApplicationsState(applications, draggedApplication, newStage, applicationsChangingStage);
        }
    });
    return newApplicationGroups;
}
const DroppableColumns = ({ hiringProcessStages, dndDirection, isDragging, applicationGroups, isHiringProcessActive, selectedApplications, onCardSelected, selectedCount, setApplicationDetail, draggingCardId, }) => {
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (hiringProcessStages || [])
            .sort((a, b) => a.orderNumber - b.orderNumber)
            .map(stage => {
            const isHalfSize = stage.name === types_1.EOfferApplicationStage.hired || stage.name === types_1.EOfferApplicationStage.rejected;
            return ((0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.Droppable, { droppableId: stage.name, direction: dndDirection, children: (provided, snapshot) => ((0, jsx_runtime_1.jsx)(HiringProcessColumn_1.HiringProcessColumn, { columnType: stage.name, isDragging: isDragging, applicationGroups: applicationGroups, isHiringProcessActive: isHiringProcessActive, selectedApplications: selectedApplications, onCardSelected: onCardSelected, selectedCount: selectedCount, setApplicationDetail: setApplicationDetail, draggingCardId: draggingCardId, provided: provided, snapshot: snapshot, isHalfSize: isHalfSize })) }, stage.id));
        }) }));
};
function HiringProcessColumns({ applications, setApplicationDetail, setApplications, isHiringProcessActive, intl, setIsSendMessageModalOpen, setShowFinishHiringProcessModal, offer, selectedApplications, setSelectedApplications, transformApplicationsToGroups, hiringProcessStages, }) {
    const [applicationGroups, setApplicationGroups] = react_1.default.useState(null);
    const [isDragging, setIsDragging] = react_1.default.useState(false);
    const isLgOrLowerLayout = (0, react_styled_1.useBreakpoint)((0, styled_breakpoints_1.down)('lg'));
    const dndDirection = isLgOrLowerLayout ? 'horizontal' : 'vertical';
    const [draggingCardId, setDraggingCardId] = react_1.default.useState(0);
    const selectedCount = react_1.default.useMemo(() => {
        return selectedApplications.length;
    }, [selectedApplications]);
    react_1.default.useEffect(() => {
        setApplicationGroups(transformApplicationsToGroups(applications));
    }, [applications]);
    const onDragStart = react_1.default.useCallback(value => {
        setDraggingCardId(Number(value.draggableId));
        const isDraggedCardSelected = selectedApplications.some(application => application.id === Number(value.draggableId));
        if (!isDraggedCardSelected) {
            setSelectedApplications([]);
        }
        setIsDragging(true);
    }, [isDragging, selectedApplications]);
    const onDragEnd = react_1.default.useCallback(async (result) => {
        const { source, destination, draggableId, } = result;
        if (!destination) {
            return null;
        }
        const applicationsChangingStage = [];
        const selectedApplicationsChangingStage = [];
        const newApplicationGroups = actualizeOfferApplicationStatuses(destination, selectedApplications, applications, applicationGroups, applicationsChangingStage, selectedApplicationsChangingStage, draggableId);
        try {
            const replaceApplicationsWithNewStage = (application) => applicationsChangingStage.find(app => app.id === application.id) || application;
            if (applicationsChangingStage.length) {
                setApplications(applications.map(replaceApplicationsWithNewStage));
            }
            if (selectedApplicationsChangingStage.length) {
                setSelectedApplications(selectedApplicationsChangingStage);
            }
            setApplicationGroups(newApplicationGroups);
            if (source.droppableId !== destination.droppableId && applicationsChangingStage.length) {
                await Api.OfferApplication.setStageGroup(applicationsChangingStage.map(app => app.id), destination.droppableId, offer.id);
            }
            await Api.Admin.updateColleaguesOffers();
        }
        catch (err) {
            // eslint-disable-next-line no-console
            console.error(err);
            antd_1.notification.error({
                message: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.error',
                }),
                description: intl.formatMessage({
                    id: 'forms.offer_notification_subscription_form.something_went_wrong',
                }),
            });
        }
        finally {
            setIsDragging(false);
        }
    }, [applicationGroups, selectedApplications, applications]);
    const onCardSelected = react_1.default.useCallback(application => {
        const isApplicationSelected = selectedApplications.find(app => app.id === application.id);
        if (isApplicationSelected) {
            const restOfTheApplications = selectedApplications.filter(app => app.id !== application.id);
            setSelectedApplications(restOfTheApplications);
        }
        else {
            setSelectedApplications([...selectedApplications, application]);
        }
    }, [selectedApplications]);
    if (!applicationGroups) {
        return null;
    }
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(HiringProcessHeader_1.HiringProcessHeader, { isHiringProcessActive: isHiringProcessActive, setShowFinishHiringProcessModal: setShowFinishHiringProcessModal, offer: offer, selectedApplications: selectedApplications, openSendMessageModal: setIsSendMessageModalOpen, setSelectedApplications: setSelectedApplications, applications: applications, selectedCount: selectedCount, hiringProcessStages: hiringProcessStages }), (0, jsx_runtime_1.jsx)(HiringProcessColumns_style_1.Columns, { children: (0, jsx_runtime_1.jsx)(react_beautiful_dnd_1.DragDropContext, { onDragEnd: onDragEnd, onDragStart: onDragStart, children: (0, jsx_runtime_1.jsx)(DroppableColumns, { hiringProcessStages: hiringProcessStages, dndDirection: dndDirection, isDragging: isDragging, applicationGroups: applicationGroups, isHiringProcessActive: isHiringProcessActive, selectedApplications: selectedApplications, onCardSelected: onCardSelected, selectedCount: selectedCount, setApplicationDetail: setApplicationDetail, draggingCardId: draggingCardId }) }) })] }));
}
